import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-709a237e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "circle" }
const _hoisted_2 = { class: "circle-inner" }
const _hoisted_3 = { class: "time" }

import { toRefs, ref, onMounted, onUnmounted } from "vue"

interface Props {
  sec: number
}

export default /*#__PURE__*/_defineComponent({
  __name: 'Progress',
  props: {
    sec: null
  },
  setup(__props: any) {

const props = __props as {
  sec: number
};

_useCssVars(_ctx => ({
  "19027b93": (animationSec.value)
}))



const { sec } = toRefs(props);

const animationSec = ref(`${sec.value}s`);

const timeLeft = ref(sec.value);

let timer: number | undefined;

onMounted(() => {
  timer = setInterval(() => {
    if(timeLeft.value > 0) {
      timeLeft.value -= 1;
    } else {
      clearInterval(timer)
    }
  }, 1000);
})

onUnmounted(() => {
  if (timer) clearInterval(timer);
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(timeLeft.value), 1)
    ])
  ]))
}
}

})